import React from 'react';
import styled from 'styled-components';
import { OrderHistoryEntry } from '../../types/order';
import { SymbolPrecisionsResponse } from '../../services/infoService'; // Import the correct type
import { formatDateTime, formatPrice, formatSize, formatFee } from '../../utils/formatters'; // Import new formatters

// Reuse Table styling from above or common styles
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  color: #ccc;
  th, td {
    padding: 0.4rem 0.6rem;
    text-align: left;
    border-bottom: 1px solid #333;
  }
  th {
    color: #aaa;
    font-weight: bold;
    background-color: #2a2a2a;
    position: sticky;
    top: 0;
  }
   tbody tr:hover {
    background-color: #252525;
  }
`;

const SideText = styled.span<{ side: 'buy' | 'sell' }> `
  color: ${({ side }) => (side === 'buy' ? '#10b981' : '#ef4444')};
  font-weight: bold;
  text-transform: uppercase;
`;

interface OrderHistoryTableProps {
  history: OrderHistoryEntry[];
  symbolPrecisions: SymbolPrecisionsResponse; // Use the imported type
}

const OrderHistoryTable: React.FC<OrderHistoryTableProps> = ({ history, symbolPrecisions }) => {
  if (!history || history.length === 0) {
    return null; // Or render an empty state message
  }

  // Helper function to get precision, with fallback
  const getPrecision = (symbol: string) /*: SymbolPrecisionDetail */ => {
    // Access the nested details correctly
    return symbolPrecisions[symbol] || { price_decimals: 2, size_decimals: 3 }; 
  };

  return (
    <div style={{ maxHeight: '300px', overflowY: 'auto' }}> {/* Example scrollable container */}
      <Table>
        <thead>
          <tr>
            <th>Time</th>
            <th>Symbol</th>
            <th>Side</th>
            <th>Type</th>
            <th>Avg Price</th>
            <th>Filled</th>
            <th>Status</th>
            <th>Fee</th>
          </tr>
        </thead>
        <tbody>
          {history.map((entry) => {
            const precision = getPrecision(entry.symbol);
            return (
              <tr key={entry.order_id + entry.timestamp}> {/* Combine for potential duplicate OIDs in history */}
                <td>{formatDateTime(entry.timestamp, 'compact')}</td> {/* Use compact format */}
                <td>{entry.symbol}</td>
                <td><SideText side={entry.side}>{entry.side}</SideText></td>
                <td>{entry.order_type}</td>
                <td>{formatPrice(entry.price, precision.price_decimals)}</td> {/* Use formatter with precision */}
                <td>{formatSize(entry.filled_size, precision.size_decimals)}</td> {/* Use formatter with precision */}
                <td>{entry.status}</td>
                <td>{formatFee(entry.fee, entry.fee_currency)}</td> {/* Use fee formatter */}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default OrderHistoryTable; 